
import React, { Component, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HeaderSample from "../common/headerSample";
import Button from 'react-bootstrap/Button';
import { URL, USER } from "../../constants/constant";
import {_axios} from '../../plugins/axios'
import { geolocated } from "react-geolocated";
import { Form, Modal } from "react-bootstrap";
import PackageDetails  from "../common/packageDetails"

class OrderDetailsCollected extends Component {

    constructor(props) {
        super(props);
        this.state={
            userdata: USER.user,
            orderStatus: null,
            orderDetails: null,
            statusDetails: null,
            cameraToggle: false,
            sampleCollection: localStorage.getItem("phlebo_start_order_trip_details") ? JSON.parse(localStorage.getItem("phlebo_start_order_trip_details")) : null,
            orderId: this.props.match.params.orderId,
            showSnackbar: false,
            messageSnacks: '',
            showReachedButton: localStorage.getItem("phlebo_start_order_trip_details") ? false : true,
            acceptDisable: true,
            lat: '11.0553N',    //pass the latitude
            lon: '76.9940E',   //pass the longitude
            location: '4, opp to fire station, 1, Bannerghatta Main Rd, Bengaluru, Karnataka 560029', //pass the location
            loader: true,
            latitude : "0.0",
            longitude: "0.0",
            labCentersAvailable: [],
            labAssigned: true,
            reassignLab: false,
            labId: null,
            labCentersAvailable: [],
            showPackageInfo: false,
            loadPackageDetails: false,
            latlongEventTriggerFunction : (ev) => {
                const that = this;
                console.log("lat long received event triggered",ev.detail);
            
                if (ev.detail !== null && ev.detail !== undefined) {
                    const latlong = ev.detail.split(",");
                    console.log("lat long split in an arr ",latlong);
                    if(latlong !== null && latlong !== undefined) {
                        this.state.latitude = latlong[0]
                        this.state.longitude = latlong[1]
                        that.markOrderReached()
                    } else {
                        that.showSnackbarFun("Location not received1, cannot continue", 2500)
                    }   
                } else {
                    that.showSnackbarFun("Location not received, cannot continue", 2500)
                }
                ev.stopImmediatePropagation();
            }
        }

    }


    componentDidMount() {
        this.addEventListeners();
        this.getOrderDetails()
    }

    componentWillUnmount() {
        this.cleanupListener();
    }

    cleanupListener() {
        if (typeof android !== "undefined" && android !== null) {
            window.removeEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
            console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
        }
    }

    addEventListeners() {
        if (typeof android !== "undefined" && android !== null) {
            window.addEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
            console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
        }
    }

    getOrderDetails() {
        const that = this;
        let url = URL.dev_url;
        let route = url + 'getorders'
        let obj = {
            phleboId: this.state.userdata.phleboId,
            orderId: parseInt(this.props.match.params.orderId)
        }

        that.setState({
            loader : true
        })

        _axios.post(route, obj)
            .then(function (response) {

            var data ;

            if ( response.data.sampleTakenOrders && response.data.sampleTakenOrders.length && response.data.sampleTakenOrders[0] ) {
                data = response.data.sampleTakenOrders;
            } else if ( response.data.completedOrders && response.data.completedOrders.length && response.data.completedOrders[0] ) {
                data = response.data.completedOrders;
            } else {
                data = response.data.sampleTakenOrders;
            }
            console.log(data);
            if (response.data.success) {
                USER.orderDetails = response.data;
                localStorage.setItem("order_details", JSON.stringify(response.data));
                that.setState({
                    orderDetails: response.data,
                    statusDetails: data,
                    loadPackageDetails: true,
                    customerNumber: data[0].patientDetails[0].phoneNumber
                }, () => {
                    localStorage.setItem('customer_phoneNumber', data[0].patientDetails[0].phoneNumber)
                })
                that.getLabCenters()
                that.fetchImages(data[0])
            }   
        }).catch(function (error) {
            that.setState({
                loader : false
            })
        })
    }
    getLabCenters() {
        const that = this;
        that.setState({
            loader : true
        })
        let route = URL.dev_url + 'getAllSPCByCity?city=' + USER.user.city
        _axios.get(route).then(function(res) {
            that.setState({
                loader : false,
                labCentersAvailable: res.data,
            })
        }).catch(function(err) {
            console.log(err);
            that.setState({
                loader : false,
                labAssigned: false
            })
        })
    }
    showPackageInfoModal(){
        this.setState({
            showPackageInfo: !this.state.showPackageInfo
        })
    }
    handleLabCenterChange(event) {
        event.preventDefault();
        this.setState({labId: event.target.value});
    }
    updateLabCenter(val) {
        const that = this;
        if(!this.state.labId) {
            this.showSnackbarFun("Please select lab center", 3000);
            return
        }
        let route = URL.dev_url + 'updateSPCForOrderId'
        _axios.post(route, {
            "orderId": this.state.statusDetails[0].orderId,
            "spcId" : this.state.labId || val
        }).then(function(res) {
            window.location.reload();
            that.setState({
                labAssigned: true
            })
        }).catch(function(err) {
            console.log(err)
        })
    }

    redirectToOTP (orderId, phoneNo) {
        let x = '/otp/customer/'+ orderId;
        localStorage.setItem("customer_phoneNumber", JSON.stringify(phoneNo));
        this.props.history.push(x);
    }

    redirectToOrderDetails () {
        let x =  '/orders'
        this.props.history.push(x);
    }

    fetchImages(statusDetails) {
        let phleboImageURL, sampleImageURL;
        _axios
          .get(`${URL.dev_url}downloadGuid?guid=${statusDetails.phleboImage[0]}`)
          .then((response) => {
            phleboImageURL = response.data.signedUrl;
            this.setState({
              phleboImageURL: phleboImageURL
            })
          });
        _axios
          .get(`${URL.dev_url}downloadGuid?guid=${statusDetails.patientDetails[0].sampleImage[0]}`)
          .then((response) => {
            sampleImageURL = response.data.signedUrl;
            this.setState({
              sampleImageURL: sampleImageURL
            })
          });
    }

    render() {

        
        return (
            <div>
                <div className="main">
                {
                this.state.loader ? <p style={{textAlign:'center'}}>Loading...</p> : <p>
                    <div className="order-details-dashboard"> 
                        <div>
                        {
                            !this.state.loader ? <HeaderSample titleCall={false} orderHeader={this.state.statusDetails[0]} noCall={this.state.statusDetails[0].noCall}></HeaderSample> : ''
                        }
                        </div>
                        <div>
                            <Container>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <div className="p-10">
                                            <div className="font-size-sm">
                                                <i className="fa fa-flask width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                TESTS
                                                <button className="btn btn-default -m-t-10" onClick={() => this.showPackageInfoModal()}><svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="20px" height="20px">    <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z"/></svg></button>
                                            </div>
                                            <div className="font-size-smd bold">
                                                <ol>
                                                    {this.state.orderDetails ? this.state.statusDetails[0].tests.map(elem => {
                                                        return <li key={elem.testId}> {elem.testName} 

                                                            { 
                                                            elem.testDetails != null ? 
                                                            <div className="display-flex justify-content-space-between p-b-10">
                                                                <div>
                                                                    { "Test Details : " + elem.testDetails}
                                                                    </div>   
                                                            </div>
                                                            : ""
                                                            }
                                                            </li>
                                                    }) : ''}
                                                </ol>
                                                
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="p-b-20">
                                    <Col xs={12} md={12}>
                                        <div className="p-10">
                                            <div className="font-size-sm">
                                                <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                Customer Address
                                            </div>
                                            <div className="font-size-smd bold p-l-15">
                                                {
                                                    this.state.orderDetails && this.state.statusDetails[0].patientDetails[0].addressLine1 ? <span> {this.state.statusDetails[0].patientDetails[0].addressLine1}, </span> : ''
                                                }
                                                {
                                                    this.state.orderDetails && this.state.statusDetails[0].patientDetails[0].addressLine2 ? <span> {this.state.statusDetails[0].patientDetails[0].addressLine2}, </span> : ''
                                                }
                                                {this.state.orderDetails ? this.state.statusDetails[0].patientDetails[0].landmark : ''}  -  {this.state.orderDetails ? this.state.statusDetails[0].patientDetails[0].pincode : ''}
                                            </div>
                                        </div>

                                        <div className="p-10">
                                            <div className="font-size-sm">
                                                <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                <span>Lab Address</span>
                                                <button 
                                                hidden = "hidden"
                                                onClick={() => {
                                                    this.setState({
                                                        reassignLab: !this.state.reassignLab
                                                    })
                                                }} className="btn btn-default btn-sm patientEdit m-b-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                    <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                                </svg> 
                                                </button>
                                            </div>
                                            <div className="font-size-smd bold p-l-15">
                                    {   
                                        this.state.statusDetails && this.state.statusDetails[0].labDetails && this.state.statusDetails[0].labDetails.AssignedLab && !this.state.reassignLab ? 
                                        <>
                                        <span> {this.state.statusDetails[0].labDetails.AssignedLab}, </span>
                                        <span> {this.state.statusDetails[0].labDetails.AssignedLabAddress 
                                            + ", "
                                            + this.state.statusDetails[0].labDetails.AssignedLabPincode} </span>
                                        </> : 
                                        <Form onSubmit={(e)=>this.updateLabCenter(this.state.labId)}>
                                            <Form.Group controlId="formGroupSelectLabCenter">
                                                <Form.Label>Select a Lab Center</Form.Label>
                                                <Form.Control as="select" onChange={(e)=>this.handleLabCenterChange(e)}>
                                                    <option value="">Select</option>
                                                    { 
                                                        this.state.labCentersAvailable.map((each, idx) => (
                                                            // {each.labId}
                                                            <option key={idx} value={each.labid}>{each.labName + ', ' + each.labaddressline1}</option>
                                                        ))
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                            <Button variant="primary" type="submit"  className="text-align-center w-100"> Save </Button>
                                        </Form>
                                    }
                                    </div>
                                        </div>
                                    </Col>
                                </Row>
                                {(this.state.statusDetails[0].phleboImage || this.state.statusDetails[0].patientDetails[0].sampleImage ) &&
                                <Row>
                                    {this.state.statusDetails[0].phleboImage &&
                                    <Col xs={12} md={6} className="p-2">
                                    <div className="card" style={{width: "100"}}>
                                        <div class="card-body">
                                            <h5 class="card-title">Phelbo: </h5>
                                        </div>
                                        <img className="card-img-top" src={`${this.state.phleboImageURL}`} alt="Card image cap"></img>
                                        
                                        </div>
                                    </Col>}
                                    {this.state.statusDetails[0].patientDetails[0].sampleImage &&
                                    <Col xs={12} md={6} className="p-2">
                                    <div className="card" style={{width: "100"}}>
                                        <div class="card-body">
                                            <h5 class="card-title">Test Samples: </h5>
                                        </div>
                                        <img className="card-img-top" src={`${this.state.sampleImageURL}`} alt="Card image cap"></img>
                                        
                                        </div>
                                    </Col>}
                                </Row>}
                             
                                <Row>
                                        <Col xs={12} md={12}>
                                            <div>
                                                <p>
                                                &nbsp;
                                                </p>
                                                </div>
                                            </Col>
                                </Row>
                                <Row>
                                        <Col xs={12} md={12}>
                                            <div>
                                                <p>
                                                &nbsp;
                                                </p>
                                                </div>
                                            </Col>
                                </Row>
                                <Row>
                                        <Col xs={12} md={12}>
                                            <div>
                                                <p>
                                                &nbsp;
                                                </p>
                                                </div>
                                            </Col>
                                </Row>
                            </Container>
                        </div>

                        <div>
                            <Container>
                                <Row>
                                    <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                                        <div className="display-flex justify-content-space-between">
                                            <Col>
                                                
                                                <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => {this.redirectToOrderDetails()}}>Back</button>
                                                
                                            </Col>
                                            
                                            {this.state.statusDetails[0].orderStatus.currentStatusId === 5 && <Col>
                                                
                                                <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => {this.redirectToOTP(this.state.statusDetails[0].orderId, this.state.statusDetails[0].patientDetails[0].phoneNumber)}}>OTP Verification</button>
                                                
                                            </Col>}

                                        </div>
                                    </div>
                                </Row>
                            </Container>
                        </div>
                </div>
                </p>
                }

                </div>
                {this.state.loadPackageDetails && < PackageDetails showPackageInfo={this.state.showPackageInfo} showPackageInfoModal={() => this.showPackageInfoModal()} appointmentId={this.state.statusDetails[0].appointmentId} packageName={this.state.statusDetails[0].tests[0].testName}/>}
            </div>
        )
    }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: true,
    },
    userDecisionTimeout: 50000,
})(OrderDetailsCollected);